import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function B2BQuotes() {
  const { user } = useAuth();
  const [quotes, setQuotes] = useState([]);
  useEffect(() => {
    if (!user) return;
    api.get("/quotes/mine").then(r => setQuotes(r.data)).catch(() => {});
  }, [user]);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "buyer" && user.role !== "admin_broker" && user.role !== "super_admin") {
    return <div className="container-xl py-20">Area riservata a buyer B2B.</div>;
  }
  return (
    <div data-testid="b2b-quotes-page" className="container-xl py-10">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--accent))] mb-2">Preventivi</div>
      <h1 className="editorial-heading text-5xl text-[hsl(var(--foreground))]">I tuoi preventivi</h1>
      <div className="mt-8 space-y-4">
        {quotes.length === 0 && <div className="text-[hsl(var(--muted-foreground))]">Nessun preventivo ancora. Richiedi un preventivo dalla scheda prodotto.</div>}
        {quotes.map(q => (
          <div key={q.id} data-testid={`quote-${q.id}`} className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-sm p-5">
            <div className="flex justify-between items-start gap-4">
              <div>
                <div className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))]">Preventivo #{q.id.substring(0, 8)}</div>
                <div className="editorial-heading text-xl mt-1 text-[hsl(var(--foreground))]">{q.items.length} referenze</div>
                <div className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{new Date(q.created_at).toLocaleString()} · {q.target_channel || "—"}</div>
              </div>
              <div className="text-right">
                <div className="text-2xl editorial-heading text-[hsl(var(--accent))]">€{q.total.toFixed(2)}</div>
                <span className="chip bg-[hsl(var(--accent))]/20 text-[hsl(var(--accent))]">{q.status}</span>
              </div>
            </div>
            <div className="mt-4 border-t border-[hsl(var(--border))] pt-3 space-y-1">
              {q.items.map((it, i) => (
                <div key={i} className="text-sm flex justify-between">
                  <span>{it.name}</span>
                  <span className="text-[hsl(var(--muted-foreground))]">{it.quantity} × €{it.unit_price.toFixed(2)} = €{it.line_total.toFixed(2)}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
